export const translations = {
    TITLE: 'vulnerablyOlderAdvise-title',
    DESCRIPTION: 'vulnerablyOlderAdvise-description',
};
